var render = function render(){var _vm=this,_c=_vm._self._c;return _c('iframe',{attrs:{"src":`${_vm.source}?providerId=${_vm.data.providerId}&memberId=${_vm.data.memberId}`,"frameborder":"0","height":"100%","width":"100%"}})
}
var staticRenderFns = []

export { render, staticRenderFns }